import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "page-layout" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = {
  key: 0,
  class: "page-layout__header"
}
const _hoisted_4 = {
  key: 0,
  class: "page-layout__breadcrumb"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Címlap ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" › ")
const _hoisted_7 = {
  key: 1,
  class: "page-layout__top"
}
const _hoisted_8 = {
  key: 2,
  class: "page-layout__title"
}
const _hoisted_9 = {
  key: 3,
  class: "page-layout__description"
}
const _hoisted_10 = ["data-io-article-url"]
const _hoisted_11 = {
  key: 0,
  class: "page-layout__side"
}
const _hoisted_12 = {
  key: 1,
  class: "page-layout__footer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavLink = _resolveComponent("NavLink")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.title || _ctx.description || _ctx.hasSlot('topheader') || _ctx.hasSlot('subheader'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_ctx.breadcrumb.length)
              ? (_openBlock(), _createElementBlock("nav", _hoisted_4, [
                  _createVNode(_component_NavLink, {
                    class: "page-layout__breadcrumb-item",
                    to: "/"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.breadcrumb, (item) => {
                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                      _hoisted_6,
                      _createVNode(_component_NavLink, {
                        class: "page-layout__breadcrumb-item",
                        to: item.url
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ], 64))
                  }), 256))
                ]))
              : _createCommentVNode("", true),
            (_ctx.hasSlot('topheader'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _renderSlot(_ctx.$slots, "topheader")
                ]))
              : _createCommentVNode("", true),
            (_ctx.title)
              ? (_openBlock(), _createElementBlock("h1", _hoisted_8, [
                  _renderSlot(_ctx.$slots, "titleicon"),
                  _createTextVNode(" " + _toDisplayString(_ctx.title), 1)
                ]))
              : _createCommentVNode("", true),
            _renderSlot(_ctx.$slots, "titleaction"),
            (_ctx.description)
              ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.description), 1))
              : _createCommentVNode("", true),
            _renderSlot(_ctx.$slots, "banner"),
            _renderSlot(_ctx.$slots, "subheader")
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["page-layout__row", {'page-layout__row--grid': _ctx.hasSlot('side')}])
      }, [
        _createElementVNode("div", {
          class: "page-layout__main",
          "data-io-article-url": _ctx.url
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 8, _hoisted_10),
        (_ctx.hasSlot('side'))
          ? (_openBlock(), _createElementBlock("aside", _hoisted_11, [
              _renderSlot(_ctx.$slots, "side")
            ]))
          : _createCommentVNode("", true),
        (_ctx.hasSlot('footer'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _renderSlot(_ctx.$slots, "footer")
            ]))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _renderSlot(_ctx.$slots, "after")
  ]))
}